

import React from "react";
import { Box,useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseCard from "../../../components/Cards/Card";
import CustomButton from "../../../components/CustomButton";
import CustomText, { textStyles } from "../../../components/CustomText";
import profiledone from "../../../assets/profiledone.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import face from "../../../assets/face.png";
import facepopup from "../../../assets/facepopup.png";
import facepopup2 from "../../../assets/facepopup2.png";
import { useTranslation } from "react-i18next";
import { useEffect,useState } from "react";
const FaceScanning = () => {
      const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm","md"));
        const isLaptop = useMediaQuery(theme.breakpoints.between("md","lg"));
  const navigate = useNavigate();
    const { t } = useTranslation();
const [showPopup1, setShowPopup1] = React.useState(false);
const [showPopup2, setShowPopup2] = React.useState(false);

React.useEffect(() => {
  const timer1 = setTimeout(() => {
    setShowPopup1(true);

    const timer2 = setTimeout(() => {
      setShowPopup2(true);

      const timer3 = setTimeout(() => {
        navigate("/registration-verification");
      },1500);

      return () => clearTimeout(timer3);
    }, 2500);

    return () => clearTimeout(timer2);
  }, 2500);

  return () => clearTimeout(timer1);
}, []);
   

  return (
    <Box sx={{ py:isMobile?5: 8, px: 2 }}>
      <BaseCard maxWidth={isMobile ? "100%" : isTablet?"50%":isLaptop? "30%":"30%"}>
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
            <Box sx={{ width:isMobile?55:isTablet?70: 93, height: 2, backgroundColor: "#091E4224" }} />
                <img src={profiledone} style={{ width: 25, height: 25 }} alt="done" />
            <Box sx={{  width:isMobile?55:isTablet?70: 93, height: 2, backgroundColor: "#091E4224" }} />
                     <Box sx={{ width: 25, height:25, borderRadius: "50%", backgroundColor: theme.palette.primary.main, color: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>3</Box>
          </Box>
        </Box>
        <CustomText
          sx={{ ...textStyles.h4, color: "#172B4D", textAlign: "left", fontSize: "26px",letterSpacing:"0px !important" }}
        >
           {t("faceScanTitle")}
        </CustomText>
        <CustomText
          sx={{ ...textStyles.body5, color: "#6B778C", pt: 1.2, textAlign: "left" ,letterSpacing:"0px !important"}}
        >
        {t("faceScanSubtitle")}
        </CustomText>
      <Box sx={{mt:4,px:2}}>
        <img src={face} style={{width:"80%",height:"80%",objectFit:"contain"}}/>
        </Box>
  
    

          <Box sx={{ display: "flex", justifyContent: "flex-end",mt: 4 }}>
            <CustomButton
              label={t("back")}
              variant="text"
              onClick={() => navigate(-1)}
              sx={{ color: "black", px:6,backgroundColor:"white" , height:20, "&:hover": {
      backgroundColor: "#ffffff", // or just "white"
    }}}
            />
            <CustomButton      label={t("next")} type="submit" size='medium' sx={{px:6,height:20}} />
          </Box>
      </BaseCard>
{showPopup1 && !showPopup2 && (
  <Box sx={popupStyle}>
    <img src={facepopup} alt="Popup 1" style={{ width: 360, borderRadius: 8 }} />
  </Box>
)}

{showPopup2 && (
  <Box sx={popupStyle}>
    <img src={facepopup2} alt="Popup 2" style={{ width: 360, borderRadius: 8 }} />
  </Box>
)}
    </Box>
  );
};
const popupStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

export default FaceScanning;